import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Divino Amor',
  favIconName: 'favicon-divino-amor',
  name: 'divinoamor',
  facebookUrl: 'https://www.facebook.com/sitedivinoamor/',
  instagramUrl: 'https://www.instagram.com/divinoamor_oficial/',
  twitterUrl: 'https://twitter.com/divinoamor',
};

export default branding;
